// extracted by mini-css-extract-plugin
export default {"circle":"circle-Yvg__","row":"row-X3UOG","label":"label-kFIGk"};